import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { SerieProposal } from './serie-proposal'
import { serieProposalActions } from './serie-proposal.actions'
import * as fromSerieProposal from './serie-proposal.reducer'
import { SerieProposalService } from './serie-proposal.service'

@Injectable()
export class SerieProposalEffects extends ResourceEffects<SerieProposal> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public serieProposalService: SerieProposalService
  ) {
    super(
      fromSerieProposal.FEATURE_NAME,
      serieProposalService,
      serieProposalActions,
      actions$
    )
  }
}
